/** Native source order and MIME declarations let the browser choose a rendition. */
export function setVideoSources(video, sources) {
    video.removeAttribute('src');
    video.replaceChildren();
    for (const format of ['webm', 'mp4']) {
        if (!sources[format]) continue;
        const source = video.ownerDocument.createElement('source');
        source.dataset.videoFormat = format;
        source.type =
            sources[`${format}_type`] ||
            (format === 'webm' ? 'video/webm; codecs="vp9"' : 'video/mp4');
        source.src = sources[format];
        video.append(source);
    }
}

export function readVideoSources(video) {
    const sources = {};
    video.querySelectorAll('source[src]').forEach((source) => {
        const format =
            source.dataset.videoFormat || ((source.type || '').includes('vp9') ? 'webm' : 'mp4');
        sources[format] = source.src;
    });
    return sources;
}

/** A failed WebM may try its MP4 once; autoplay rejection is not a media error. */
export function videoMp4Fallback(current, { mp4 = '', webm = '' }) {
    return current && current === webm && mp4 && mp4 !== webm ? mp4 : '';
}

const initializedVideos = new WeakSet();

function initializeNativeVideo(video) {
    if (initializedVideos.has(video)) return;
    initializedVideos.add(video);
    const sources = readVideoSources(video);
    let retried = false;
    let playbackStarted = false;
    video.addEventListener('play', () => {
        playbackStarted = true;
    });
    const retryMp4 = () => {
        const fallback = videoMp4Fallback(video.currentSrc, sources);
        if (retried || !fallback || !video.isConnected) return;
        retried = true;
        video.src = fallback;
        video.load();
        if (playbackStarted || video.autoplay) video.play().catch(() => {});
    };
    video.addEventListener('error', retryMp4);
}

/** Legacy/native players keep HTML source fallbacks and never acquire sources eagerly. */
export function initVideoVariants(root = document) {
    if (root.matches?.('video[data-video-variants]')) initializeNativeVideo(root);
    root.querySelectorAll?.('video[data-video-variants]').forEach(initializeNativeVideo);
}
